{
  "general": {
    "loginFailed": "Your username or password were incorrect, please try again.",
    "refreshTokenExpired": "You have been logged in for too long. For security reasons, please log in again.",
    "open": "Open",
    "save": "Save",
    "close": "Close",
    "cancel": "Cancel",
    "error": "Error"
  },
  "validationErrors": {
    "genericError": "This value cannot be saved."
  },
  "schema": {
    "transactions": "Transactions",
    "accounts": "Accounts",
    "projects": "Projects",
    "reports": "Reports",
    "blog": "Blog",
    "pleaseEnterValue": "Please enter a new value for this attribute",
    "transactionTypes": {
      "sale": "sale",
      "purchase": "purchase",
      "split": "split"
    },
    "deposits": {
      "transaction": {
        "ownName": "Transaction",
        "date": {
          "label": "Date",
          "description": "Date of the transaction."
        },
        "otherParty": {
          "label": "Transaction party",
          "description": "Sender or receipient of the transaction amount."
        },
        "otherPartyAccount": {
          "label": "Account number",
          "description": "IBAN (account no.) of the sender or receipient."
        },
        "description": {
          "label": "Description",
          "description": "Description of the transaction."
        },
        "amount": {
          "label": "Amount",
          "description": "This transaction's amount of money in your base currency."
        },
        "accountCurrencyAmount": {
          "label": "Amount",
          "description": "This transaction's amount of money in account currency."
        },
        "currency": {
          "label": "Account currency",
          "description": "This account's currency."
        },
        "fxAmount": {
          "label": "Foreign currency amount",
          "description": "Optional. If the transaction was conducted in a foreign currency, this is its original amount."
        },
        "fxCurrency": {
          "label": "Foreign currency symbol",
          "description": "Optional. If the transaction was conducted in a foreign currency, this is its three-letter symbol."
        },
        "simulated": {
          "label": "Simulated transaction",
          "description": "Values in this column are true (checked) if the transaction is simulated."
        },
        "incomeFromInterest": {
          "label": "Income from capital",
          "description": "Values in this column are true (checked) if this transaction is an income from capital (interests, dividends etc.)."
        }
      },
      "account": {
        "ownName": "Bank account",
        "name": "Bank name",
        "country": "Country",
        "accountName": {
          "label": "Account name",
          "tooltip": "What name would you like to see for this account in the system?",
          "error": "Please enter a designation for this account."
        },
        "baseCurrency": {
          "label": "Base currency",
          "tooltip": "What currency does this account use?"
        },
        "iban": {
          "label": "IBAN",
          "tooltip": "This account's IBAN (account number)",
          "placeholder": "DE12345678901234567890"
        },
        "bic": {
          "label": "BIC",
          "tooltip": "International bank code (called >BIC<) for the bank where this account is at. Up to 11 characters long. Used to identify a bank in an international setting."
        },
        "bankName": {
          "label": "Bank name",
          "tooltip": "Name of the bank where this account is at.",
          "placeholder": "Sparkasse Bielefeld"
        },
        "syncType": {
          "label": "Synchronisation",
          "tooltip": "How would you like to sync this account?",
          "placeholder": "Select sync type"
        },
        "depositType": {
          "label": "Account type",
          "tooltip": "What kind of account is this?",
          "placeholder": "Select account type"
        },
        "countryCode": {
          "label": "Country",
          "tooltip": "What country is this account in?",
          "placeholder": "Select country"
        },
        "category": {
          "label": "Category",
          "tooltip": "What category does this account belong to?",
          "placeholder": "Select category"
        },
        "parameters": {
          "syncType": {
            "manual": "manual",
            "automatic": "automatic"
          },
          "depositType": {
            "savings-account": "checking",
            "time-deposit": "savings"
          }
        }
      }
    },
    "stocks": {
      "transaction": {
        "date": {
          "label": "Date",
          "description": "Date of the transaction."
        },
        "displaySymbol": {
          "label": "Security symbol*",
          "description": "Symbol of traded security, such as ISIN, WKN or CUSIP. Optional."
        },
        "displayName": {
          "label": "Security name",
          "description": "Stock name."
        },
        "transactionAmount": {
          "label": "Amount",
          "description": "Quantity of securities bought or sold."
        },
        "transactionPrice": {
          "label": "Price (base currency)",
          "description": "Unit price paid, in your base currency."
        },
        "transactionCurrency": {
          "label": "Currency",
          "description": "Currency of the transaction."
        },
        "transactionOriginalPrice": {
          "label": "Price (transaction currency)",
          "description": "Unit price paid, in transactioion currency."
        }
      },
      "account": {
        "brokerName": {
          "label": "Provider name",
          "tooltip": "Which broker is this account with?",
          "placeholder": "DepotX"
        },
        "accountNo": {
          "label": "Account number",
          "tooltip": "What is the number of your brokerage account?",
          "placeholder": "C12345678"
        },
        "username": {
          "label": "Username",
          "tooltip": "What is your username for this account?",
          "placeholder": "user01"
        },
        "syncType": {
          "label": "Synchronisation",
          "tooltip": "How would you like to sync this account?",
          "placeholder": "Select sync type"
        },
        "ownCurrentAccount": {
          "label": "Cash account IBAN",
          "tooltip": "Which current account is this brokerage account linked to?",
          "placeholder": "Select current account"
        },
        "countryCode": {
          "label": "Country",
          "tooltip": "What country is this account in?",
          "placeholder": "Select country"
        },
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?"
        }
      }
    },
    "meta-comment": "the entries below are realEstate quotes, but this is only used in import of quotes, so leaving it be for now",
    "realEstate": {
      "transaction": {
        "date": {
          "label": "Date",
          "description": "Date of the valuation."
        },
        "currency": {
          "label": "Currency",
          "description": "The currency of the valuation."
        },
        "quote": {
          "label": "Price",
          "description": "Valuation in that currency."
        },
        "quoteBaseCurrency": {
          "label": "Price (base currency)",
          "description": "Valuation in your base currency."
        },
        "note": {
          "label": "Note",
          "description": "Optional. Any valuation details you may want to record."
        }
      },
      "account": {
        "kindOfProperty": "What kind of property is this?",
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?"
        },
        "valuationParameters": {
          "type": {
            "label": "Building or apartment"
          },
          "subtype": {
            "label": "Property type",
            "tooltip": "What kind of building / apartment is this?"
          },
          "streetAddress": {
            "label": "Street and number",
            "tooltip": "Where is your property located?",
            "placeholder": "Hochstr. 12"
          },
          "zip": {
            "label": "Postal code",
            "tooltip": "What postal code does your property have?",
            "placeholder": "33602",
            "error": "Please provide a postal code."
          },
          "district": {
            "label": "District / Town",
            "tooltip": "If your property is in a Stadtkreis, enter the name of the district (Stadtteil). Otherwise enter the name of the town or village.",
            "placeholder": "Mitte"
          },
          "city": {
            "label": "Stadtkreis / Landkreis",
            "tooltip": "Name of the Stadtkreis (city) or Landkreis (county) your property is located in.",
            "placeholder": "Bielefeld",
            "error": "Please provide Stadtkreis or Landkreis name."
          },
          "countryCode": {
            "label": "Country",
            "tooltip": "What country is your property located in?",
            "placeholder": "Germany",
            "error": "Please provide a country."
          },
          "completeArea": {
            "label": "Complete floor area",
            "tooltip": "How big is your entire property (in m²)?",
            "placeholder": "100"
          },
          "livingArea": {
            "label": "Floor area",
            "tooltip": "How big is the living area of your property (in m²)?",
            "placeholder": "88",
            "error": "Please indicate how large your property is."
          },
          "floor": {
            "label": "Floor",
            "tooltip": "On which floor is your property located?",
            "placeholder": "3"
          },
          "totalFloors": {
            "label": "Building floors",
            "tooltip": "How many floors in total does the building have?",
            "placeholder": "4"
          },
          "rooms": {
            "label": "Rooms",
            "tooltip": "How many rooms does your property have?",
            "placeholder": "3"
          },
          "flooring": {
            "label": "Flooring",
            "tooltip": "What kind of flooring does your property have?"
          },
          "interiorLevel": {
            "label": "Interior standard",
            "tooltip": "How would you rate the interior of your property?"
          },
          "condition": {
            "label": "Current condition",
            "tooltip": "How would you rate the current condition of your property?"
          },
          "lotArea": {
            "label": "Lot area",
            "tooltip": "How big is the lot your property is located on (in square meters)?",
            "placeholder": "450"
          },
          "constructionYear": {
            "label": "Construction year",
            "tooltip": "When was your property built?",
            "placeholder": "2010"
          },
          "energyClass": {
            "label": "Energy consumption",
            "tooltip": "Enter the amount of required kWh per m² per year. If you only know the energy efficiency class, look up the average value for that class and enter it here.",
            "placeholder": 60
          },
          "heatingType": {
            "label": "Heating type",
            "tooltip": "What kind of heating does your property have?"
          },
          "floorHeating": {
            "label": "Underfloor heating?",
            "tooltip": "Does the property have underfloor heating?"
          },
          "lastRenovationYear": {
            "label": "Year of last renovation",
            "tooltip": "When was the property last renovated?",
            "placeholder": "2020"
          },
          "privateParkingSpaces": {
            "label": "Parking spots",
            "tooltip": "How many private parking spots are available for your property?",
            "placeholder": 1
          },
          "garden": {
            "label": "Garden?",
            "tooltip": "Does the property have a garden?"
          },
          "bathTub": {
            "label": "Bathtub?",
            "tooltip": "Does the property have a bathtub?"
          },
          "bathWithWindows": {
            "label": "Bath with windows?",
            "tooltip": "Does the property have a bathroom with windows?"
          },
          "fullHeightWindows": {
            "label": "Full-height windows?",
            "tooltip": "Does the property have full-height windows?"
          }
        },
        "parameters": {
          "type": {
            "apartment": "Apartment",
            "building": "Building"
          },
          "subtype": {
            "building": {
              "farm": "Farm",
              "special-building": "Special Building",
              "bungalow": "Bungalow",
              "castle": "Castle",
              "semi-detached": "Semi-Detached",
              "detached": "Detached",
              "apartment-building": "Apartment Building",
              "terraced": "Terraced",
              "terraced-corner": "Terraced Corner",
              "villa": "Villa",
              "other": "Other"
            },
            "apartment": {
              "top-floor": "Top Floor",
              "ground-floor": "Ground Floor",
              "other-floor": "Other Floor",
              "high-ground-floor": "High Ground Floor",
              "loft": "Loft",
              "two-levels": "Two Levels",
              "penthouse": "Penthouse",
              "souterrain": "Souterrain",
              "with-balcony": "With Balcony",
              "other": "Other"
            }
          },
          "interiorLevel": {
            "simple": "Simple",
            "normal": "Normal",
            "high": "High",
            "luxus": "Luxury"
          },
          "condition": {
            "new": "New",
            "newly-renovated": "Newly Renovated",
            "well-maintained": "Well Maintained",
            "modernized": "Modernized",
            "flexible": "Flexible",
            "like-new": "Like New",
            "needs-renovation": "Needs Renovation",
            "refurbished": "Refurbished",
            "completely-renovated": "Completely Renovated",
            "needs-repair": "Needs Repair"
          },
          "heatingType": {
            "gas": "Gas",
            "oil": "Oil",
            "electricity": "Electricity",
            "district": "District",
            "wood": "Wood",
            "coal": "Coal",
            "solar": "Solar",
            "block": "Block",
            "stock": "Stock",
            "floor": "Floor",
            "nachtspeicher": "Storage Heating",
            "wärmekraft": "Thermal Power",
            "central": "Central"
          },
          "flooring": {
            "carpet": "Carpet",
            "parquet": "Parquet",
            "tiles": "Tiles",
            "laminate": "Laminate",
            "floorboards": "Floorboards"
          }
        }
      }
    },
    "loans": {
      "account": {
        "parameters": {
          "type": {
            "annuity": "Fixed rate (annuity)",
            "fixedPrincipal": "Variable rate (fixed principal)",
            "interestOnly": "Interest only"
          },
          "period": {
            "month": "Monthly",
            "quarter": "Quarterly",
            "annual": "Yearly"
          },
          "direction": {
            "received": "Loan taken",
            "granted": "Loan granted"
          }
        },
        "type": {
          "label": "Loan type",
          "tooltip": "What kind of loan is this? Fixed rate, fixed capital repayment etc.",
          "placeholder": "Select loan type",
          "error": "Loan type is incorrect."
        },
        "direction": {
          "label": "Taken or granted?",
          "tooltip": "Did you borrow money (loan taken) or lent it (loan granted)?",
          "error": "Loan taken/granted is incorrect."
        },
        "loanAmount": {
          "label": "Loan amount (currency)",
          "tooltip": "How much money did you borrow?",
          "placeholder": "-100000",
          "error": "Please enter the loan amount."
        },
        "interestRate": {
          "label": "Interest rate",
          "tooltip": "What is the interest rate of your loan? Changes during loan term are possible.",
          "error": "Please enter the interest rate."
        },
        "period": {
          "label": "Installment frequency",
          "tooltip": "How often do you do repayments? Changes during loan term are possible.",
          "error": "Please enter the loan period."
        },
        "iban": {
          "label": "IBAN",
          "tooltip": "This account's (loan's account) IBAN (account number)",
          "placeholder": "DE12345678901234567890"
        },
        "bankName": {
          "label": "Bank name",
          "tooltip": "This account's (loan's account) IBAN (account number)",
          "placeholder": "DE12345678901234567890"
        },
        "percentRepaidAnnually": {
          "label": "Repayment rate (Tilgung)",
          "tooltip": "How much of the loan do you repay annually? Changes during loan term are possible.",
          "error": "Please enter the repayment rate."
        },
        "contractEndDate": {
          "label": "Loan end date",
          "tooltip": "When does the loan contract end?",
          "error": "Please enter the contract end date."
        },
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) send and receive payments for this loan?"
        },
        "interestCalcMonthEnd": {
          "label": "Interest calculation at month end?",
          "tooltip": "Does your bank calculate your payments at the end of the month (yes) or at its beginning?"
        },
        "connectedProjectId": {
          "label": "Connected project",
          "tooltip": "Which project shows the simulated repayment schedule for this loan?"
        }
      },
      "transaction": {
        "ownName": "Transaction",
        "date": {
          "label": "Date",
          "description": "Date of the transaction."
        },
        "otherParty": {
          "label": "Transaction party",
          "description": "Sender or receipient of the transaction amount."
        },
        "otherPartyIban": {
          "label": "Account number",
          "description": "IBAN (account no.) of your loan account."
        },
        "description": {
          "label": "Description",
          "description": "Description of the transaction."
        },
        "quantity": {
          "label": "Principal",
          "description": "This repayment's principal part in your account currency."
        },
        "quantityInterest": {
          "label": "Interest",
          "description": "This repayment's interest part in your account currency."
        }
      }
    },
    "pension": {
      "account": {
        "parameters": {
          "useSpecialQuote": {
            "payoutOnlyContributionsToDate": "Pension on contributions to-date",
            "payoutOnlyContributionsToDateIndexed": "Pension on contributions to-date (with interest)",
            "payoutAllPlannedContributions": "Pension on all future contributions",
            "payoutAllPlannedContributionsIndexed": "Pension on all future contributions (with interest)",
            "payoutLumpSumVerrentet": "Lump sum converted to perpetual pension"
          },
          "contributionsFrequency": {
            "0": "One-time",
            "1": "Monthly",
            "3": "Quarterly",
            "12": "Yearly"
          },
          "payoutsFrequency": {
            "0": "One-time",
            "1": "Monthly",
            "3": "Quarterly",
            "12": "Yearly"
          },
          "frequencyUnit": {
            "0": "indefinitely",
            "1": "months",
            "12": "years"
          }
        },
        "product": "pension product",
        "name": {
          "label": "Pension product name",
          "tooltip": "What is the name of this pension product?",
          "placeholder": "My Riester pension",
          "error": "Please provide product name."
        },
        "currency": {
          "label": "Account currency",
          "tooltip": "What currency does this pension product use for contributions and payouts?"
        },
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) send and receive payments for this pension product?"
        },
        "connectedDepositMode": {
          "error": "Please select an option here."
        },
        "productPurchaseDate": {
          "label": "Purchase date",
          "tooltip": "When did you purchase this product? This date does not have to be very precise, it is used to show you how the present value of this product has been changing over time.",
          "error": "Please enter an (approximate) purchase date.",
          "errorInvalid": "Please enter a date which is valid.",
          "errorFuture": "This date may not be in the future"
        },
        "initialQuotes": {
          "label": "Original payout estimates",
          "tooltip": "What were the initial payout estimates that were given to you when you signed the contract?",
          "error": "Original payout estimates missing"
        },
        "contributionsSelfPaid": {
          "label": "Contributions self-paid?",
          "tooltip": "Set this to YES if you pay the contributions. If it is your employer, set it to NO.",
          "error": "Contributions self-paid require a value"
        },
        "contributionsAmounts": {
          "label": "Contribution amount",
          "placeholder": 100,
          "tooltip": "Enter the current contribution amount (if self-paid). You can set different amounts for different periods later on.",
          "error": "Please enter an (approximate) contribution amount."
        },
        "contributionsFrequency": {
          "label": "Contribution frequency",
          "tooltip": "How often do you pay contributions to this product?",
          "error": "Contribution frequency is not set"
        },
        "contributionsDeductible": {
          "label": "Are contributions tax-deductible?",
          "tooltip": "Do you receive a tax benefit on this product?",
          "error": "Contribution deductible information is not set"
        },
        "contributionsIndexed": {
          "label": "Will contribution change over time?",
          "tooltip": "Will the contribution amount be adjusted over time? Enable to index by inflation or a custom rate.",
          "error": "Contribution growth setting is missing."
        },
        "payoutsPhaseStart": {
          "label": "Payout phase start",
          "tooltip": "When is the first payout to take place? We only need an approximate date here. We use it to simulate future payouts. You can change it later.",
          "error": "Please enter the (approximate) payout phase start date."
        },
        "payoutsFrequency": {
          "label": "Payout frequency",
          "tooltip": "Is it a monthly, quarterly, annual or one-time payout?",
          "error": "Payout frequency not set"
        },
        "payoutsDurationUserInput": {
          "label": "Payout paid for how long?",
          "tooltip": "For how long will the payouts be provided? Select 'indefinitely' from the menu if there is no end date.",
          "error": "Payout duration not set"
        },
        "payoutsDuration": {
          "label": "Payout duration",
          "tooltip": "For how long will the payouts be provided? Enter '0' if indefinitely, otherwise enter a number of months (12 for one year, 120 for ten years etc.).",
          "error": "Payout duration not set"
        },
        "payoutsTaxable": {
          "label": "Is payout taxable?",
          "tooltip": "Do you pay taxes on the payout you receive?",
          "error": "Payout taxable not provided."
        },
        "payoutsIndexed": {
          "label": "Will payout change over time?",
          "tooltip": "Will the payout amount be adjusted over time? Enable to index by inflation or a custom rate.",
          "error": "Payout growth not set."
        },
        "discountRateIsInflation": {
          "label": "Use inflation rate to index values for this account?",
          "tooltip": "Select YES to use inflation rate to simulate payout and contribution growth as well as calculate current value of the account. Select NO to provide your own index rate.",
          "error": "Please choose how to index values in this account."
        },
        "customDiscountRate": {
          "label": "Custom index rate (%)",
          "tooltip": "Annual percentage rate used to index contributions/payouts.",
          "error": "Please enter a custom contribution index rate.",
          "placeholder": 2
        },
        "useSpecialQuote": {
          "label": "Current value calculation",
          "tooltip": "Which pension estimate should we use to calculate the present value of this pension product?",
          "error": "Pension estimate not provided."
        },
        "discountRate": {
          "label": "Product interest rate",
          "tooltip": "Interest rate used to calculate present value of this product as well as it's future growth, if any. Leave it open to use the inflation rate specified in settings.",
          "error": "Product interst rate not set.",
          "placeholder": 2.3
        },
        "fxRate": {
          "label": "Today's exchange rate of {{accountCurrency}} to {{baseCurrency}}: ",
          "tooltip": "To keep things simple, we recommend using current exchange rate. Feel free to use any exchange rate you feel is better suited for the long term.",
          "apply": "Automatically convert all to {{baseCurrency}}"
        }
      },
      "transaction": {
        "date": {
          "label": "Date",
          "description": "On what date did the provider communicate these new values?"
        },
        "currency": {
          "label": "Currency",
          "description": "The currency of the valuation."
        },
        "payoutOnlyContributionsToDate": {
          "label": "Pension from contributions to-date",
          "description": "Pension that you would receive if you stopped paying contributions today."
        },
        "payoutOnlyContributionsToDateIndexed": {
          "label": "Pension from contributions to-date (inflation-adjusted)",
          "description": "Pension that you would receive if you stopped paying contributions today, but growing with inflation until pension payout phase."
        },
        "payoutAllPlannedContributions": {
          "label": "Pension from all future contributions",
          "description": "Pension that you would receive if you keep paying contributions until pension payout phase."
        },
        "payoutAllPlannedContributionsIndexed": {
          "label": "Pension from all future contributions (inflation-adjusted)",
          "description": "Pension that you would receive if you keep paying contributions until pension payout phase, but growing with inflation until pension payout phase."
        },
        "payoutLumpSumVerrentet": {
          "label": "Lump sum converted to perpetual pension",
          "description": "Capital you have accumulated will be converted into a perpetual annuity. We will automatically calculate the recurring payment."
        }
      }
    },
    "objectsOfValue": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?"
        },
        "name": {
          "label": "Object name",
          "tooltip": "Under what name shall we display this object?",
          "placeholder": "Mercedes 450 SEL",
          "error": "Please provide the object name."
        },
        "currency": {
          "label": "Account currency",
          "tooltip": "What currency does this pension product use for contributions and payouts?"
        },
        "userInputPurchaseDate": {
          "label": "Purchase date",
          "tooltip": "When did you purchase this object?",
          "error": "Please enter the purchase date."
        },
        "userInputPurchaseValueAccountCurrency": {
          "label": "Purchase price in {{currency}}",
          "tooltip": "How much did you pay for this object?",
          "error": "Please enter the purchase value."
        },
        "userInputPurchaseValueBaseCurrency": {
          "label": "Purchase price in {{currency}}",
          "tooltip": "How much did you pay for this object?",
          "error": "Please enter the purchase value."
        },
        "fxRate": {
          "label": "Exchange rate of {{accountCurrency}} to {{baseCurrency}} on {{date}} was",
          "tooltip": "For your convenience we looked up the exchange rate on the day you indicated.",
          "apply": "Calculate purchase price in {{baseCurrency}}"
        },
        "quantity": {
          "label": "Quantity purchased",
          "tooltip": "If applicable here, how many objects did you buy initially? Default value is 1."
        }
      }
    },
    "metals": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?"
        },
        "name": {
          "label": "Account name",
          "tooltip": "How would you like to call this account?",
          "placeholder": "Bank deposit box",
          "error": "Please provide the account name"
        },
        "currency": {
          "label": "Account currency",
          "tooltip": "In which currency shall we track the assets in this account?"
        }
      },
      "transaction": {
        "parameters": {
          "assetMetal": {
            "gold": "gold",
            "silver": "silver",
            "platinum": "platinum",
            "palladium": "palladium",
            "other": "other"
          }
        }
      }
    },
    "unlistedShares": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?",
          "error": "Please select an option"
        },
        "connectedDepositMode": {
          "error": "Please select an option"
        },
        "name": {
          "label": "Company name",
          "tooltip": "What is the name of this company?",
          "placeholder": "My company",
          "error": "Please provide the company name"
        },
        "currency": {
          "label": "Currency",
          "tooltip": "In which currency shall we track your investments in this company?"
        },
        "date": {
          "label": "Company start date",
          "tooltip": "When did you create the company? An approximate date is sufficient.",
          "error": "Please enter a date"
        },
        "upac": {
          "label": "Starting capital",
          "tooltip": "How much starting capital did you invest in the company?",
          "placeholder": 25000,
          "error": "Please enter a value"
        },
        "upbc": {
          "label": "Starting capital (base currency)",
          "tooltip": "How much starting capital is that in your overall base currency?",
          "placeholder": 25000,
          "error": "Please enter a value"
        },
        "quantity": {
          "label": "Number of shares",
          "tooltip": "How many shares did you assume? If not sure, enter 1.",
          "placeholder": 1,
          "error": "Please enter a value"
        }
      }
    },
    "crypto": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Connected bank account(s)",
          "tooltip": "Which bank account(s) receive proceeds from this account's assets?"
        },
        "name": {
          "label": "Account name",
          "tooltip": "How would you like to call this account?",
          "placeholder": "Bank deposit box",
          "error": "Please provide the account name"
        },
        "brokerName": {
          "label": "Provider name",
          "tooltip": "Which exchange or broker is this account with?",
          "placeholder": "Binance"
        },
        "accountNo": {
          "label": "Account idenfitier",
          "tooltip": "What is the identifier of your account?",
          "placeholder": "C12345678"
        }
      }
    }
  }
}